// api
import { fetchApi } from '@/api'
import router from '@/router'

// actions
const papeleriaRequestsAll = (context) => {
  let url = 'papeleria/requests'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REQUESTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaRequestsForm = (context) => {
  let url = 'papeleria/requests/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REQUESTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaRequestsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'papeleria/requests/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REQUESTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const papeleriaRequestsCreate = (context, payload) => {
  let url = 'papeleria/requests'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_REQUESTS_CREATE', response)
      router.push('create')
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaRequestsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/users/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_REQUESTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaRequestsDelete = (context, payload) => {
  let url = 'papeleria/requests'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_REQUESTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const validateCredentialPapeleria = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_REQUESTS_VALIDATE', response)
      router.push('/papeleria/requests/recreate')
    })
    .catch((error) => {
      console.error(error)
    })
}

/* const validateCredential = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_REQUESTS_VALIDATE', response)
      router.push('recreate')
    })
    .catch((error) => {
      console.error(error)
    })
} */

export default {
  papeleriaRequestsAll,
  papeleriaRequestsForm,
  papeleriaRequestsShow,
  papeleriaRequestsCreate,
  papeleriaRequestsUpdate,
  papeleriaRequestsDelete,
  validateCredentialPapeleria
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/requests/actions.js